// extracted by mini-css-extract-plugin
module.exports = {"section":"Nav_section__JDewy"};